// extracted by mini-css-extract-plugin
module.exports = {"hasRedlParams":"blocredl_hasRedlParams__t5r06"};